import { useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { ROUTES } from "../App";
import { IMAGES } from "../constants/images";

const MyCommunityItem = ({ communities, navigate, setSelectedId, setIsDeleteOpen }) => {
    // state to track loading per image
    const [loadedImages, setLoadedImages] = useState({});

    const handleImageLoad = (id) => {
        setLoadedImages((prev) => ({ ...prev, [id]: true }));
    };

    const formatLastMessage = (message) => {
        if (!message) return "No messages yet";
        if (message === "📷 Image") return message;
        if (message.length > 25) return `${message.substring(0, 25)}...`;
        return message;
    };

    return (
        <div className="space-y-4 mt-6">
            {communities.map((community) => {
                const isLoaded = loadedImages[community.id];
                return (
                    <div
                        key={community.id}
                        onClick={() => navigate(`${ROUTES.COMMUNITY_CHAT}/${community.id}`)}
                        className="flex items-center justify-between space-x-4 py-2 
             border-t border-gray-200 dark:border-[#D9D9D9]/20
             cursor-pointer 
             hover:bg-gray-100 dark:hover:bg-white/5 
             hover:rounded-lg px-2 transition"
                    >
                        <div className="flex items-center space-x-4">
                            {/* Avatar */}
                            <div className="relative w-16 h-16 flex-shrink-0">
                                {!isLoaded && (
                                    <div className="absolute inset-0 bg-gray-300 dark:bg-gray-700 rounded-full animate-pulse border-2 border-gray-200 dark:border-gray-700"></div>
                                )}
                                <img
                                    src={community.imageUrl ? community.imageUrl : 'https://firebasestorage.googleapis.com/v0/b/zylen-app.firebasestorage.app/o/group-photo.png?alt=media&token=5109cfab-8e78-43c4-9d86-0ed964c87346'}
                                    alt={community.name}
                                    className={`w-full h-full rounded-full object-cover border-2 border-gray-200 dark:border-gray-700 transition-opacity duration-300 ${isLoaded ? "opacity-100" : "opacity-0"}`}
                                    onLoad={() => handleImageLoad(community.id)}
                                    onError={() => handleImageLoad(community.id)}
                                />
                                {community.hasUnread && (
                                    <span className="w-4 h-4 bg-red-500 rounded-full absolute top-2 right-1 border-2 border-black"></span>
                                )}
                            </div>

                            {/* Name and Role */}
                            <div className="flex flex-col min-w-0 text-black dark:text-white">
                                <p className="text-sm font-semibold truncate">
                                    {community.name}
                                </p>
                                {community.lastMessage && (
                                    <span className="text-xs text-gray-500 dark:text-gray-400 mt-1 truncate">
                                        {formatLastMessage(community.lastMessage)}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="flex flex-col items-end gap-2 w-fit">
                            <div className="flex flex-wrap items-center justify-end md:gap-4 gap-2 text-sm w-full">
                                <button
                                    className="flex items-center gap-1 text-green-500 hover:cursor-pointer bg-gray-200 dark:bg-gray-500/30 px-2 py-1 rounded-md hover:bg-green-100 dark:hover:bg-green-900/30"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate(`${ROUTES.NEW_COMMUNITY}/${community.id}`);
                                    }}
                                >
                                    <FaEdit /> Edit
                                </button>
                                <span className="text-gray-400">|</span>
                                <button
                                    className="flex items-center gap-1 text-red-500 hover:cursor-pointer bg-gray-200 dark:bg-gray-500/30 px-2 py-1 rounded-md hover:bg-red-100 dark:hover:bg-red-900/30"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedId(community.id);
                                        setIsDeleteOpen(true);
                                    }}
                                >
                                    <FaTrash /> Delete
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default MyCommunityItem;
